export default "__VITE_ASSET__4ef64a83__"